import { useCallback } from "react";

import { useMarketingVoucherI18nFormModelContext } from "../../../../_context";

export const useVoucherI18nDescription = () => {
	const { viewModel, onSetViewModel } = useMarketingVoucherI18nFormModelContext();

	const { description } = viewModel;

	const onSetDescription = useCallback(
		(input: string) => {
			onSetViewModel([{ key: "description", value: { ...description, value: input } }]);
		},
		[description, onSetViewModel],
	);

	return {
		description,
		onSetDescription,
	};
};
